export type Job = {
    id: number
    status: JobStatus
    messages: JobMessage[]
}

export type JobMessage = {
    priority: JobMessagePriority,
    type: JobMessageType,
    text: string
}

export enum JobMessagePriority {
    Debug = 0,
    Info = 1,
    Warning = 2,
    Error = 3
}

export enum JobMessageType {
    General = 0,
    ProcessPhase = 1,
    ItemHeader = 2,
    Item = 3
}

export enum JobStatus {
    Unknown = 0,
    Waiting = 1,
    ForUser = 2,
    ForTimeslot = 4,

    Active = 64,
    Stage1 = 128,
    Stage2 = 256,

    Done = 1 << 12,
    WithWarnings = 1 << 13,
    WithErrors = 1 << 14,
    WithRollback = 1 << 15,
    WithNoChanges = 1 << 16
}